import { Guid, Nillable } from '@web/utils';
import { PublicCartItemStatus } from './public-cart-item-status';
import { PublicCartItemAttribute } from './public-cart-item-attribute';
import { Multimedia } from '@web/shared/module/multimedia';
import { ProductType } from '../../shared/enums';

export class PublicCartItem {
  public constructor(
    private readonly data: {
      attributes: PublicCartItemAttribute[];
      id: Guid;
      image: Multimedia;
      name: string;
      subName: Nillable<string>;
      price: number;
      quantity: number;
      slug?: Nillable<string>;
      status: PublicCartItemStatus;
      type: ProductType;
      unitPrice: number;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get subName(): Nillable<string> {
    return this.data.subName;
  }

  public get unitPrice(): number {
    return this.data.unitPrice;
  }

  public get image(): Multimedia {
    return this.data.image;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get slug(): Nillable<string> {
    return this.data.slug;
  }

  public get type(): ProductType {
    return this.data.type;
  }

  public get price(): number {
    return this.data.price;
  }

  public get status(): PublicCartItemStatus {
    return this.data.status;
  }

  public get attributes(): PublicCartItemAttribute[] {
    return this.data.attributes;
  }
}
